import React, { createContext, Dispatch, ReactElement, ReactNode, SetStateAction, useContext, useState } from 'react';

export interface LayoutContextShape {
    isAutoFillHeightDisabled: boolean;
    setIsAutoFillHeightDisabled: Dispatch<SetStateAction<boolean>>;
}

const initialContext: LayoutContextShape = {
    isAutoFillHeightDisabled: false,
    setIsAutoFillHeightDisabled: (): void => undefined,
};

const LayoutContext = createContext(initialContext);

export const LayoutContainerContextProvider = ({ children }: { children: ReactElement | ReactNode | ReactNode[] }) => {
    // Provides ability to disable the main layout container's auto-fill-height class, at the component level
    const [isAutoFillHeightDisabled, setIsAutoFillHeightDisabled] = useState(false);

    return (
        <LayoutContext.Provider value={{ isAutoFillHeightDisabled, setIsAutoFillHeightDisabled }}>
            {children}
        </LayoutContext.Provider>
    );
};

export const useLayoutContainerContext = () => useContext(LayoutContext);
